<template>
  <div>
    <CountrySelect :selectedCountry="selectedCountry" @currency="currency" />
    <LanguageSelect :selectedLanguage="selectedLanguage" />
    <CurrencySelect :selectedCurrency="localCurrency" :key="localCurrency.code" />
  </div>
</template>

<script>
import CountrySelect from './global_settings/CountrySelect.vue'
import LanguageSelect from './global_settings/LanguageSelect.vue'
import CurrencySelect from './global_settings/CurrencySelect.vue'

export default {
  props: {
    selectedCountry: Object,
    selectedCurrency: Object,
    selectedLanguage: Object
  },
  data() {
    return {
      localCurrency: this.selectedCurrency
    };
  },
  methods: {
    currency(currency) {
      this.localCurrency = currency
    }
  },
  components: {
    CountrySelect,
    LanguageSelect,
    CurrencySelect
  },
}
</script>
